<template>
  <div class="custom-datepicker mx-3 my-2" ref="datepickerWrapper">
    <custom-date-picker
      mode="range"
      v-model="selectedValue"
      :show-caps="showCaps"
      :is-double-paned="isDoublePaned"
      :min-date="minDate"
      :max-date="maxDate"
      :show-day-popover="false"
      :attributes='attrs'
      :popoverVisibility="visibility"
      id="datepicker"
      :popoverAlign="alignPopover">
      <v-btn color="primary" block style="text-transform: none" outline @click="toggleDatePicker">
        {{ selectedPeriod }}
        <v-icon v-if="!popoverVisibility" right dark  transition="scale-transition" >expand_more</v-icon>
        <v-icon v-else right dark transition="scale-transition" >expand_less</v-icon>
      </v-btn>
    </custom-date-picker>
  </div>
</template>

<script>
import moment from 'moment'
/**
 * Implementa componente externo [v-calendar](https://docs.vcalendar.io/) para
 * personalização na seleção de períodos. Principalmente utilizado na view
 * StudentTrays para selecionar o período em que deseja visualizar as bandejas.
*/
export default {
  props: {
    // Periodo selecionado
    value: {
      type: Object,
      required: true
    },
    // Data mínima em que pode selecionar um periodo
    minDate: {
      type: Date,
      default: null
    },
    // Data máxima em que se pode selecionar um período
    maxDate: {
      type: Date,
      default: null
    },
    // Controla a quantidade de painéis estão sendo exibidos
    isDoublePaned: {
      type: Boolean,
      default: false
    },
    // Destaca os dias limites do período selecionado
    showCaps: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    selectedValue: {},
    popoverVisibility: false,
    attrs: [
      {
        key: 'today',
        highlight: {
          backgroundColor: '#ff8080'
          // Other properties are available too, like `height` & `borderRadius`
        },
        dates: new Date(2018, 0, 1)
      }
    ]
  }),

  computed: {
    alignPopover () {
      let breakpoint = this.$vuetify.breakpoint.name
      let mobile = breakpoint === 'xs' || breakpoint === 'sm'
      return mobile ? 'center' : 'right'
    },

    visibility () {
      return this.popoverVisibility ? 'visible' : 'none'
    },

    selectedPeriod () {
      const startDate = this.formatTimestamp(this.selectedValue.start)
      const endDate = this.formatTimestamp(this.selectedValue.end)
      return `De ${startDate} a ${endDate}`
    }
  },

  watch: {
    value (newVal) {
      this.selectedValue = newVal
    },

    selectedValue (newVal) {
      // Emite quando existe um novo valor a ser atualizado
      // @arg Nova data ou período selecionado
      this.$emit('input', newVal)
      this.popoverVisibility = false
    }
  },

  created () {
    this.selectedValue = Object.keys(this.value).length === 0 ? this.getDateInitial() : this.value
  },

  mounted () {
    document.addEventListener('mousedown', this.handleClickOutside)
    document.addEventListener('touchstart', this.handleClickOutside)
  },

  destroyed () {
    document.removeEventListener('mousedown', this.handleClickOutside)
    document.removeEventListener('touchstart', this.handleClickOutside)
  },

  methods: {
    // @vuese
    // Formata a data passada via parametro
    formatTimestamp (value) {
      if (value) {
        return moment(new Date(value)).format('DD/MM/YY')
      }
    },
    // @vuese
    // Seleciona primeiro período como a semana atual
    getDateInitial () {
      let today = moment().day()
      let dateSelected = {}

      switch (today) {
        case 0:
        case 1:
          dateSelected.start = moment().weekday(-6).format()
          dateSelected.end = moment().weekday(-2).format()
          return dateSelected
        case 2:
        case 3:
        case 4:
        case 5:
          dateSelected.end = moment().format()
          dateSelected.start = moment().weekday(1).format()
          return dateSelected
        case 6:
          dateSelected.end = moment().weekday(5).format()
          dateSelected.start = moment().weekday(1).format()
          return dateSelected
      }
    },
    handleClickOutside (e) {
      const $datepickerRef = this.$refs.datepickerWrapper
      if ($datepickerRef && $datepickerRef.contains(e.target)) return
      if (this.popoverVisibility) { this.popoverVisibility = false }
    },
    // @vuese
    // Controla toggle do componente
    toggleDatePicker () {
      this.popoverVisibility = !this.popoverVisibility
    }
  }
}
</script>

<style lang="stylus">
  .custom-datepicker
    @media only screen and (max-width: 768px)
      flex 1
</style>
